import { useCallback, useEffect, useState } from 'react'

// Preserve size while filtering; closing the dropdown restores the natural height.
const useFilterPanelHeight = (panelRef, scopeKey) => {
  const [preserved, setPreserved] = useState({ scopeKey: null, height: 0 })
  const preserveHeight = useCallback(() => {
    const height = panelRef.current
      ? panelRef.current.getBoundingClientRect().height
      : 0
    if (Number.isFinite(height) && height > 0) {
      setPreserved({ scopeKey, height })
    }
  }, [panelRef, scopeKey])
  const resetHeight = useCallback(
    () => setPreserved({ scopeKey: null, height: 0 }),
    []
  )
  useEffect(resetHeight, [scopeKey, resetHeight])
  return {
    minimumHeight: preserved.scopeKey === scopeKey ? preserved.height : 0,
    preserveHeight,
    resetHeight
  }
}

export default useFilterPanelHeight
